// extracted by mini-css-extract-plugin
module.exports = {"Contacto":"Contacto_Contacto__1HHdV","ContactoGrid":"Contacto_ContactoGrid__1BQDB","ProyectosCardWrapper":"Contacto_ProyectosCardWrapper__3FhHR"};